import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('clinic_user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch (_) {}
    }
    setLoading(false);
  }, []);

  async function login(phone, password) {
    const { data } = await api.post('/auth/login', { phone, password });
    if (data.success && (data.data.role === 'doctor' || data.data.role === 'admin')) {
      localStorage.setItem('clinic_accessToken', data.data.accessToken);
      localStorage.setItem('clinic_refreshToken', data.data.refreshToken);
      localStorage.setItem('clinic_user', JSON.stringify(data.data));
      setUser(data.data);
      return data.data;
    }
    throw new Error('This portal is for doctors only. Please use the patient app.');
  }

  async function register(payload) {
    const { data } = await api.post('/auth/register', { ...payload, role: 'doctor' });
    if (data.success) {
      localStorage.setItem('clinic_accessToken', data.data.accessToken);
      localStorage.setItem('clinic_refreshToken', data.data.refreshToken);
      localStorage.setItem('clinic_user', JSON.stringify(data.data));
      setUser(data.data);
      return data.data;
    }
    throw new Error(data.message);
  }

  function logout() {
    localStorage.removeItem('clinic_accessToken');
    localStorage.removeItem('clinic_refreshToken');
    localStorage.removeItem('clinic_user');
    setUser(null);
  }

  function updateUser(updates) {
    const updated = { ...user, ...updates };
    setUser(updated);
    localStorage.setItem('clinic_user', JSON.stringify(updated));
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
